import React, {Component} from "react";
import Logo from "../../images/logo.png";

class Footer extends Component{
    render(){
        return(
            <footer>
                <div className="main-footer">
                    <div className="main-footer-left">
                        <div className="footer-company-info">
                            <img src={Logo} />
                            <h3>Marketplace</h3>
                        </div>
                        <p className="sec-txt small-txt">© 2021 Arata — Marketplace for Arata and digital goods.</p>
                    </div>
                    <div className="main-footer-right">
                        <div className="footer-social">
                            <i className="fab fa-facebook-square"></i>
                            <i className="fab fa-twitter"></i>
                            <i className="fab fa-linkedin"></i>
                            <i className="fab fa-whatsapp"></i>
                        </div>
                        <div className="footer-newsletter">
                            <i className="fi fi-rr-envelope"></i>
                            <input type="text" placeholder="Your Email Address" />
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>Terms of Policy</p>
                    <p>Help Center</p>
                    <p>Blog</p>
                    <p>Brand Kit</p>
                    <p>Privacy Policy</p>
                </div>
            </footer>
        );
    }
}

export default Footer;